import { BUNDLE_EXTENSION } from '../types/bundle'

export const PROJECTS_FOLDER_NAME = 'FreeCutProjects'
export const BUNDLE_FILE_ACCEPT = `${BUNDLE_EXTENSION},.zip`

export function extractProjectNameFromBundleFile(fileName: string): string {
  return fileName
    .replace(/\.zip$/i, '')
    .replace(/\s*\(\d+\)$/, '')
    .replace(/\.freecut$/i, '')
}

export function isValidProjectBundleFileName(fileName: string): boolean {
  return /\.freecut(\s*\(\d+\))?\.zip$/i.test(fileName)
}

export function formatBundleFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
